export class StudioTrialModalController {
    static $inject = ['close', 'confirm'];
    constructor(close, confirm) {
        this.close = close;
        this.confirm = confirm;
    }
    async _confirm() {
        this.confirm();
        this.close(true);
    }
    async _cancel() {
        this.close(false);
    }
}
